import MobileDetect from "mobile-detect";

const md = new MobileDetect(window.navigator.userAgent);

export const isSupport = !(
  typeof Map.prototype.keys === "undefined" ||
  typeof Array.prototype.find === "undefined"
);

export const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

export const isMobile = !!md.mobile();
export const os = md.os();
export const isAndroid = os === "AndroidOS";
export const userAgent = md.userAgent();

// export const supportedWebAssembly = (() => {
//   try {
//     if (
//       typeof WebAssembly === "object" &&
//       typeof WebAssembly.instantiate === "function"
//     ) {
//       const module = new WebAssembly.Module(
//         Uint8Array.of(0x0, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00)
//       );
//       if (module instanceof WebAssembly.Module)
//         return new WebAssembly.Instance(module) instanceof WebAssembly.Instance;
//     }
//   } catch (e) {}
//   return false;
// })();

export default md;



// WEBPACK FOOTER //
// ./src/userAgentDetect.js